import {isDefined} from '@ls/js-utils';
import CalcType from 'state/Constants/CalcType';
import IssueCountTypes from 'state/issueCount/IssueCountTypes';
import scope from './scope';

export default class IssueCountDefinition {
  #issueCountType;
  #calcType;

  static getDefault = () => new IssueCountDefinition({
    issueCountType: IssueCountTypes[1],
    calcType: CalcType.Account,
  });


  constructor(props = {}) {
    const {issueCountType, calcType} = props;
    this.#issueCountType = issueCountType;
    this.#calcType = calcType
  }

  get issueCountType() {
    return this.#issueCountType;
  }

  get calcType() {
    return this.#calcType;
  }

  setIssueCountType = (value) => new IssueCountDefinition({
    ...this.copy(),
    issueCountType: value,
  });

  setCalcType = (value) => new IssueCountDefinition({
    ...this.copy(),
    calcType: value,
  });

  get complete() {
    return isDefined(this.#issueCountType) && isDefined(this.#calcType);
  }

  get key() {
    return `${scope} - ${this.#issueCountType}, ${this.#calcType}`;
  }

  copy = () => {
    return {
      issueCountType: this.#issueCountType,
      calcType: this.#calcType,
    }
  }
}
